import { reduce } from 'lodash';
import moment from 'moment/moment';



export const EMPTY_LOCATIONS = {
  ess: {},
  tgs: {},
  tes: {},
  hp: {},
  all: {},
  specific: {},
};

const hasDevices = (location) => (location?.devices || []).length > 0;

export const filterZonesWithDevices = (zones = []) => {
  return (zones || []).reduce((result, zone) => {
    const specificLocations = (zone.specific_location || []).filter(hasDevices);

    if (!hasDevices(zone) && specificLocations.length === 0) {
      return result;
    }

    const { specific_location, ...zoneWithoutSpecificLocations } = zone;
    result.push(
      specificLocations.length > 0
        ? { ...zone, specific_location: specificLocations }
        : zoneWithoutSpecificLocations
    );

    return result;
  }, []);
};

export const extractLocationData = (data) => {
  return reduce(
    data,
    (result, location) => {
      if (location.specific_location) {
        location.specific_location.forEach((specificLocation) => {
          result[specificLocation.zone_id] = {
            ...specificLocation,
            address: {
              lat: specificLocation.latitude,
              lng: specificLocation.longitude,
            },
            zoneId: specificLocation.zone_id,
            locationId: specificLocation.zone_id,
            locationName: specificLocation.zone_name,
            locationAddress: specificLocation.zone_address || '',
            site_maps_ESS: specificLocation.site_maps_ESS
              ? specificLocation.site_maps_ESS[0]
              : '',
            site_maps_TGS: specificLocation.site_maps_TGS
              ? specificLocation.site_maps_TGS[0]
              : '',
            site_maps_TES: specificLocation.site_maps_TES
              ? specificLocation.site_maps_TES[0]
              : '',
            weather: specificLocation.daily
              .filter((_, index) => [0, 8, 16, 24, 32].includes(index))
              .map((item) => ({
                icon: item.weather[0].icon,
                tempMin: item.main.temp_min.toFixed(),
                tempMax: item.main.temp_max.toFixed(),
                day: moment(item.dt_txt).format('dddd'),
              })),
            devices: specificLocation?.devices.reduce(
              (result, machine) => ({
                ...result,
                [machine.device_mac]: {
                  ...machine,
                  machineName: machine.device_name,
                  machineMac: machine.device_mac,
                  locationId: specificLocation.zone_id,
                  locationName: specificLocation.zone_name,
                },
              }),
              {}
            ),
          };
        });
      }
      return {
        ...result,
        [location.zone_id]: {
          ...location,
          address: { lat: location.latitude, lng: location.longitude },
          zoneId: location.zone_id,
          locationId: location.zone_id,
          locationName: location.zone_name,
          locationAddress: location.zone_address || '',
          site_maps_ESS: location.site_maps_ESS
            ? location.site_maps_ESS[0]
            : '',
          site_maps_TGS: location.site_maps_TGS
            ? location.site_maps_TGS[0]
            : '',
          site_maps_TES: location.site_maps_TES
            ? location.site_maps_TES[0]
            : '',
          weather: location.daily
            .filter((_, index) => [0, 8, 16, 24, 32].includes(index))
            .map((item) => ({
              icon: item.weather[0].icon,
              tempMin: item.main.temp_min.toFixed(),
              tempMax: item.main.temp_max.toFixed(),
              day: moment(item.dt_txt).format('dddd'),
            })),
          devices: location?.devices.reduce(
            (result, machine) => ({
              ...result,
              [machine.device_mac]: {
                ...machine,
                machineName: machine.device_name,
                machineMac: machine.device_mac,
                locationId: location.zone_id,
                locationName: location.zone_name,
              },
            }),
            {}
          ),
        },
      };
    },
    {}
  );
};


export const buildAllLocations = (payload) => {
  return reduce(
    payload,
    (result, location) => {
      if (location.specific_location) {
        const specificLocations = [];
        location.specific_location.forEach((specificLocation) => {
          const allDevices = [
            ...(result[specificLocation.zone_id]?.allDevices || []),
            ...(specificLocation.devices || []),
          ];
          specificLocations.push({
            ...specificLocation,
            devices: allDevices,
          });
          result[specificLocation.zone_id] = {
            ...specificLocation,
            address: {
              lat: specificLocation.latitude,
              lng: specificLocation.longitude,
            },
            zoneId: specificLocation.zone_id,
            locationId: specificLocation.zone_id,
            locationName: specificLocation.zone_name,
            locationAddress: specificLocation.zone_address || '',
            site_maps_ESS: specificLocation.site_maps_ESS
              ? specificLocation.site_maps_ESS[0]
              : '',
            site_maps_TGS: specificLocation.site_maps_TGS
              ? specificLocation.site_maps_TGS[0]
              : '',
            site_maps_TES: specificLocation.site_maps_TES
              ? specificLocation.site_maps_TES[0]
              : '',
            weather: specificLocation.daily
              .filter((_, index) => [0, 8, 16, 24, 32].includes(index))
              .map((item) => ({
                icon: item.weather[0].icon,
                tempMin: item.main.temp_min.toFixed(),
                tempMax: item.main.temp_max.toFixed(),
                day: moment(item.dt_txt).format('dddd'),
              })),
            allDevices: allDevices,
            devices: {
              ...(result[specificLocation.zone_id]?.devices || {}),
              ...specificLocation?.devices.reduce(
                (_result, _machine) => ({
                  ..._result,
                  [_machine.device_mac]: {
                    ..._machine,
                    machineName: _machine.device_name,
                    machineMac: _machine.device_mac,
                    locationId: specificLocation.zone_id,
                    locationName: specificLocation.zone_name,
                  },
                }),
                {}
              ),
            },
          };
        });
        if (result[location.zone_id]) {}
      }
      return {
        ...result,
        [location.zone_id]: {
          ...location,
          address: { lat: location.latitude, lng: location.longitude },
          zoneId: location.zone_id,
          locationId: location.zone_id,
          locationName: location.zone_name,
          locationAddress: location.zone_address || '',
          assignUsers: location.assign_users || [],
          site_maps_ESS: location.site_maps_ESS
            ? location.site_maps_ESS[0]
            : '',
          site_maps_TGS: location.site_maps_TGS
            ? location.site_maps_TGS[0]
            : '',
          site_maps_TES: location.site_maps_TES
            ? location.site_maps_TES[0]
            : '',
          weather: location.daily
            .filter((_, index) => [0, 8, 16, 24, 32].includes(index))
            .map((item) => ({
              icon: item.weather[0].icon,
              tempMin: item.main.temp_min.toFixed(),
              tempMax: item.main.temp_max.toFixed(),
              day: moment(item.dt_txt).format('dddd'),
            })),
          devices: {
            ...result[location.zone_id]?.devices,
            ...location.devices.reduce(
              (result, machine) => ({
                ...result,
                [machine.device_mac]: {
                  ...machine,
                  machineName: machine.device_name,
                  machineMac: machine.device_mac,
                  locationId: location.zone_id,
                  locationName: location.zone_name,
                },
              }),
              {}
            ),
          },
        },
      };
    },
    {}
  );
};


export const buildSpecificLocations = (payload) => {
  return reduce(
    payload,
    (result, location) => {
      if (location.specific_location) {
        location.specific_location.forEach((specificLocation) => {
          return {
            ...result,
            [specificLocation.zone_id]: {
              ...specificLocation,
              address: {
                lat: specificLocation.latitude,
                lng: specificLocation.longitude,
              },
              zoneId: specificLocation.zone_id,
              locationId: specificLocation.zone_id,
              locationName: specificLocation.zone_name,
              locationAddress: specificLocation.zone_address || '',
              site_maps_ESS: specificLocation.site_maps_ESS
                ? specificLocation.site_maps_ESS[0]
                : '',
              site_maps_TGS: specificLocation.site_maps_TGS
                ? specificLocation.site_maps_TGS[0]
                : '',
              site_maps_TES: specificLocation.site_maps_TES
                ? specificLocation.site_maps_TES[0]
                : '',
              weather: specificLocation.daily
                .filter((_, index) => [0, 8, 16, 24, 32].includes(index))
                .map((item) => ({
                  icon: item.weather[0].icon,
                  tempMin: item.main.temp_min.toFixed(),
                  tempMax: item.main.temp_max.toFixed(),
                  day: moment(item.dt_txt).format('dddd'),
                })),
              devices: {
                ...result[specificLocation.zone_id]?.devices,
                ...specificLocation?.devices.reduce(
                  (result, machine) => ({
                    ...result,
                    [machine.device_mac]: {
                      ...machine,
                      machineName: machine.device_name,
                      machineMac: machine.device_mac,
                      locationId: specificLocation.zone_id,
                      locationName: specificLocation.zone_name,
                    },
                  }),
                  {}
                ),
              },
            },
          };
        });
      }
      return {
        ...result,
        [location.zone_id]: {
          ...location,
          address: { lat: location.latitude, lng: location.longitude },
          zoneId: location.zone_id,
          locationId: location.zone_id,
          locationName: location.zone_name,
          locationAddress: location.zone_address || '',
          assignUsers: location.assign_users || [],
          site_maps_ESS: location.site_maps_ESS
            ? location.site_maps_ESS[0]
            : '',
          site_maps_TGS: location.site_maps_TGS
            ? location.site_maps_TGS[0]
            : '',
          site_maps_TES: location.site_maps_TES
            ? location.site_maps_TES[0]
            : '',
          weather: location.daily
            .filter((_, index) => [0, 8, 16, 24, 32].includes(index))
            .map((item) => ({
              icon: item.weather[0].icon,
              tempMin: item.main.temp_min.toFixed(),
              tempMax: item.main.temp_max.toFixed(),
              day: moment(item.dt_txt).format('dddd'),
            })),
          devices: {
            ...result[location.zone_id]?.devices,
            ...location.devices.reduce(
              (result, machine) => ({
                ...result,
                [machine.device_mac]: {
                  ...machine,
                  machineName: machine.device_name,
                  machineMac: machine.device_mac,
                  locationId: location.zone_id,
                  locationName: location.zone_name,
                },
              }),
              {}
            ),
          },
        },
      };
    },
    {}
  );
};


export const applySitePlanURL = (
  locations,
  { swtName, location, specificLocation, key, url }
) => {
  const patch = (node) => {
    if (specificLocation) {
      return {
        ...node,
        [location]: {
          ...node?.[location],
          [specificLocation]: {
            ...node?.[location]?.[specificLocation],
            [key]: url,
          },
        },
      };
    }
    return {
      ...node,
      [location]: {
        ...node?.[location],
        [key]: url,
      },
    };
  };

  return {
    ...locations,
    all: patch(locations.all),
    [swtName]: patch(locations[swtName]),
  };
};
